<template>
  <div class="pop-payment-wrap">
    <div class="pop-header">
      <span class="pop-title">현금결제</span>
      <button class="btn-pop-close" @click="$.emit('closeModal')">
        닫기
        <span class="overlay"></span>
      </button>
    </div>
    <div class="pop-body">
      <div class="fieldset">
        <span class="h2">받을금액</span>
        <div class="ip-row">
          <label for="recAmt01">받을금액</label>
          <input
            type="text"
            class="ip-comm"
            id="recAmt01"
            :readonly="isProdPay"
            :value="
              (isProdPay
                ? prodAmount
                : complexUprc > 0
                ? complexUprc
                : dutchUprc > 0
                ? dutchUprc
                : totalCash
              )
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            "
          />
        </div>
        <div class="ip-row">
          <label for="recAmt02">받은금액</label>
          <input
            type="text"
            class="ip-comm"
            id="recAmt02"
            :value="
              receiveCash.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            "
            @input="inputReceiveCash()"
          />
        </div>
        <div class="ip-row">
          <label for="change">거스름돈</label>
          <input
            type="text"
            class="ip-comm"
            id="change"
            :value="
              (receiveCash - totalCash > 0 ? receiveCash - totalCash : 0)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            "
            disabled
          />
        </div>
        <div class="ip-row flex">
          <button
            type="button"
            class="btn-addamt btn-main"
            @click="addReceiveCash(1000)"
          >
            + 천원<span class="overlay"></span>
          </button>
          <button
            type="button"
            class="btn-addamt btn-main"
            @click="addReceiveCash(5000)"
          >
            + 오천원<span class="overlay"></span>
          </button>
          <button
            type="button"
            class="btn-addamt btn-main"
            @click="addReceiveCash(10000)"
          >
            + 만원<span class="overlay"></span>
          </button>
          <button
            type="button"
            class="btn-addamt btn-main"
            @click="addReceiveCash(50000)"
          >
            + 오만원<span class="overlay"></span>
          </button>
          <button
            type="button"
            class="btn-addamt btn-main"
            @click="addReceiveCash(100000)"
          >
            + 십만원<span class="overlay"></span>
          </button>
        </div>
        <div class="ip-btn-area">
          <button
            type="submit"
            class="btn-pop btn-third btn-submit"
            @click="payInCash"
          >
            단순현금결제<span class="overlay"></span>
          </button>
        </div>
      </div>

      <!-- <div class="fieldset">
        <span class="h2">현금영수증</span>
        <div class="ip-row flex">
          
          <div class="custom-radio">
            <input
              type="radio"
              name="crType"
              value="2"
              id="indi"
              label="개인"
              checked
            />
            <label for="indi">개인</label>
          </div>
          <div class="custom-radio">
            <input
              type="radio"
              name="crType"
              value="1"
              id="busi"
              label="사업자"
            />
            <label for="busi">사업자</label>
          </div>
          
          <input
            type="text"
            class="ip-comm ip-lg center"
            id="cashReceiveNum"
            :value="cashReceiveNum"
            maxlength="16"
          />
        </div>
      </div>
      <div class="ip-btn-area">
        <button type="submit" class="btn-pop btn-third btn-main">
          자진발급<span class="overlay"></span>
        </button>
        <button type="submit" class="btn-pop btn-third btn-main">
          입력요청<span class="overlay"></span>
        </button>
        <button type="submit" class="btn-pop btn-third btn-submit">
          승인요청<span class="overlay"></span>
        </button>
      </div> -->
    </div>
    <!-- 아래 요소 내 버튼들은 기본 우측 정렬, 좌측 정렬은 al-left 클래스 추가 -->
    <div class="pop-btn-area al-left">
      <!-- [팝업버튼 크기] .btn-pop: 100%, .btn-pop.btn-half: 50%, .btn-pop.btn-third: 33.33%, .btn-pop.btn-fourth: 25% -->
      <button
        type="button"
        class="btn-pop btn-fourth btn-lblue"
        @click="payInRegist"
      >
        임의등록<span class="overlay"></span>
      </button>
    </div>
  </div>
  <PopupBtn2
    v-if="isPopupBtn2"
    :popupText="popupText"
    :popupTitle="popupTitle"
    @close="isPopupBtn2 = false"
    @setYes="setYes"
  />
</template>

<script>
import popupBtn2 from "@/components/popup/PopupBtn2.vue";

export default {
  name: "cashPayment",
  data() {
    return {
      receiveCash: 0,
      change: 0,
      totalCash: this.totalUprc - this.totalDiscount - this.receivedUprc,
      popupText: "",
      popupTitle: "",
      isPopupBtn2: false,
      loadingText: "",
      isLoadingText: false,
    };
  },
  methods: {
    addReceiveCash(cash) {
      this.receiveCash += cash;
      this.receiveCash - this.totalCash;
    },
    setYes() {
      this.isPopupBtn2 = false;
      this.$.emit("openLoading", "현금결제 중입니다.");

      if (this.isComplex) {
        setTimeout(() => {
          this.$.emit("closeLoading");
          this.$.emit("closeComplexCash", this.receiveCash);
          this.$.emit("addComplexPayArr", this.receiveCash, "cash");
        }, 1000);
      } else if (this.isDutchPayment) {
        this.$.emit("closeLoading");
        this.$.emit("closeDutchCash", this.receiveCash);
      } else {
        setTimeout(() => {
          this.$.emit("closeLoading");
          this.$.emit("moveCashReceipts");
        }, 1000);
      }
    },
    payInCash() {
      this.popupTitle = "현금결제";
      this.popupText = `현금 ${this.receiveCash
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}원을<br/>결제하시겠습니까?`;

      this.isPopupBtn2 = true;
    },
    async payInRegist() {
      await this.loadingPromise("임의등록 처리 중입니다.");
      await this.loadingPromise("영수증 출력 중입니다.");
      this.$.emit("resetBasket", this.payType);
      this.$.emit("closeModal");
    },
    loadingPromise(text) {
      this.$.emit("openLoading", text);
      return new Promise((resolve) => {
        setTimeout(() => {
          this.$.emit("closeLoading");
          resolve(1);
        }, 1000);
      });
    },
    inputReceiveCash() {
      let receiveCash = event.target.value.replace(/\D/g, "");
      if (receiveCash.length == 0) receiveCash = 0;
      receiveCash = parseInt(receiveCash, 10);

      event.target.value = receiveCash;
      this.receiveCash = event.target.value;
    },
  },
  props: {
    totalUprc: Number,
    totalDiscount: Number,
    receivedUprc: Number,
    cashReceiveNum: String,
    isComplex: Boolean,
    complexUprc: Number,
    dutchUprc: Number,
    isDutchPayment: Boolean,
    isProdPay: Boolean,
    prodAmount: Number,
  },
  watch: {},
  computed: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  unmounted() {},
  components: {
    PopupBtn2: popupBtn2,
  },
};
</script>

<style src="@/assets/css/style.css" scoped></style>
<style scoped>
</style>


